import { useEffect, useState, useRef, useMemo } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Form } from 'react-bootstrap';
import { updateInvoiceLocal } from '../../store/actions';

const TermDates = () => {
    const dispatch = useDispatch();
    const rawInvoice = useSelector((state) => state.order.invoice);
    const invoice = useMemo(() => rawInvoice || {}, [rawInvoice]);
    const [termDisplay, updateTermDisplay] = useState('');
    const years = [1, 2, 3, 4, 5];

    const today = new Date();
    const currentYear = today.getFullYear();
    const currentMonth = today.getMonth();
    // academic year starts Jul 1; before July = current year - 1, July+ = current year
    const currentAcademicYear = currentMonth >= 6 ? currentYear : currentYear - 1;

    let startDateOptions = [
        { display: `Jul 1, ${currentAcademicYear}`, value: currentAcademicYear + 1 },
        { display: `Jul 1, ${currentAcademicYear + 1}`, value: currentAcademicYear + 2 },
    ];

    // If current month is Feb(1) - Jun(5) then prefer the later academic year first
    if (currentMonth >= 1 && currentMonth < 6) {
        startDateOptions = startDateOptions.reverse();
    }

    const mountedRef = useRef(false);

    // Mount-only init: set academic_year to first option if not set yet.
    useEffect(() => {
        if (mountedRef.current) return;
        mountedRef.current = true;
        // Ensure the first option is selected on mount.
        if (invoice.academic_year !== startDateOptions[0].value) {
            dispatch(updateInvoiceLocal({ academic_year: startDateOptions[0].value }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    // Update term display whenever invoice changes.
    useEffect(() => {
        if (!invoice.academic_year) return;
        const acad = +invoice.academic_year;
        const term = +invoice.license_term || 1;
        updateTermDisplay(`Jul 1, ${acad - 1} - Jun 30, ${acad + term - 1}`);
    }, [invoice]);

    const handleUpdate = (e) => {
        dispatch(updateInvoiceLocal({ [e.target.name]: e.target.value }));
    };

    return (
        <>
            <Form>
                <div className="card">
                    <div className="row">
                        <div className="col-sm">
                            <Form.Group controlId='invoiceStartDate'>
                                <Form.Label>Start Date</Form.Label>
                                <Form.Control
                                    as="select"
                                    name='academic_year'
                                    value={invoice.academic_year ? +invoice.academic_year : startDateOptions[0].value}
                                    onChange={handleUpdate}
                                >
                                    {startDateOptions.map((opt) => (
                                        <option value={opt.value} key={opt.value}>{opt.display}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </div>
                        <div className="col-sm">
                            <Form.Group controlId='invoiceLicenseTerm'>
                                <Form.Label>Years</Form.Label>
                                <Form.Control
                                    as="select"
                                    name='license_term'
                                    value={invoice.license_term}
                                    onChange={handleUpdate}
                                >
                                    {years.map((year, index) => (
                                        <option key={index}>{year}</option>
                                    ))}
                                </Form.Control>
                            </Form.Group>
                        </div>
                        <div className="col-sm">
                            <Form.Group controlId='termDates'>
                                <Form.Label>License Valid</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder={termDisplay}
                                    disabled
                                />
                            </Form.Group>
                        </div>
                    </div>
                </div>
            </Form>
        </>
    );
};

export { TermDates };


